import { render, staticRenderFns } from "./JiShiReportHome.vue?vue&type=template&id=f88b4be2&scoped=true&"
import script from "./JiShiReportHome.vue?vue&type=script&lang=js&"
export * from "./JiShiReportHome.vue?vue&type=script&lang=js&"
import style0 from "./JiShiReportHome.vue?vue&type=style&index=0&id=f88b4be2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88b4be2",
  null
  
)

export default component.exports